(() => {
  const initialize = () => {
    const hero = document.querySelector('[data-mh-hero]');
    if (!hero || hero.dataset.mhReady) return;
    hero.dataset.mhReady = 'true';
    const shell = document.querySelector('[data-mh-hero-shell]');
    const story = document.querySelector('[data-mh-story]');
    const pin = story?.querySelector('.mh-story__pin');
    const panels = [...document.querySelectorAll('[data-mh-chapter-panel]')];
    const tabs = [...document.querySelectorAll('[data-mh-chapter]')];
    const styleTabs = document.querySelector('[data-mh-style-tabs]');
    const collectionTabs = document.querySelector('[data-mh-collection-tabs]');
    const styleHeading = document.querySelector('[data-mh-style-heading]');
    const collectionHeading = document.querySelector('[data-mh-collection-heading]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = matchMedia('(min-width: 990px)');
    const scrollRoot = () => desktop.matches ? (hero.closest('.page-wrapper') || document.scrollingElement) : document.scrollingElement;
    const mobile = matchMedia('(max-width:749px)');
    const copies = hero.querySelector('.mh-hero__copy');
    const readout = story?.querySelector('.mh-machine__readout span');
    let active = panels[0]?.dataset.mhChapterPanel;
    let frame = 0;
    let manualScroll = null;
    const clamp = value => Math.max(0, Math.min(1, value));
    const warm = index => {
      for (const panel of panels.slice(index, index + 2)) panel.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
    };
    const select = id => {
      if (active === id) return;
      active = id;
      if (readout) readout.textContent = String(Number(id) + 1).padStart(2, '0');
      const selectedPanel = panels.find(panel => panel.dataset.mhChapterPanel === id);
      const collection = selectedPanel?.classList.contains('mh-story__collection');
      panels.forEach(panel => {
        const selected = panel.dataset.mhChapterPanel === id;
        panel.hidden = !selected;
        panel.classList.toggle('is-entering', selected);
      });
      tabs.forEach(tab => {
        const selected = tab.dataset.mhChapter === id;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      if (styleTabs) styleTabs.hidden = !!collection;
      if (collectionTabs) collectionTabs.hidden = !collection;
      if (styleHeading) styleHeading.hidden = !!collection;
      if (collectionHeading) collectionHeading.hidden = !collection;
      warm(panels.findIndex(panel => panel.dataset.mhChapterPanel === id));
    };
    const jump = tab => {
      const id = tab.dataset.mhChapter;
      select(id);
      if (motion.matches || !pin || !scrollRoot()) return;
      const index = panels.findIndex(panel => panel.dataset.mhChapterPanel === id);
      const top = parseFloat(getComputedStyle(pin).top) || 0;
      const rect = story.getBoundingClientRect();
      const heroTravel = Math.max(0, shell.getBoundingClientRect().height - hero.getBoundingClientRect().height);
      const travel = Math.max(0, rect.height - pin.getBoundingClientRect().height - heroTravel);
      const position = scrollRoot().scrollTop + rect.top - top + heroTravel + travel * (mobile.matches ? ((index === 0 ? .45 : index + .8) / (panels.length + .5)) : ((index + .3) / Math.max(1, panels.length)));
      manualScroll = position;
      scrollRoot().scrollTo({top:position,behavior:'instant'});
    };
    tabs.forEach(tab => {
      tab.addEventListener('click', () => jump(tab));
      tab.addEventListener('keydown', event => {
        const group = [...tab.closest('[role=tablist]').querySelectorAll('[role=tab]')];
        const index = group.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % group.length;
        if (event.key === 'ArrowLeft') next = (index + group.length - 1) % group.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = group.length - 1;
        if (next === undefined) return;
        event.preventDefault(); jump(group[next]); group[next].focus();
      });
    });
    const update = () => {
      frame = 0;
      if (!hero.isConnected) return;
      document.documentElement.classList.toggle('mh-continuous', !motion.matches);
      if (!pin || !shell) return;
      const top = parseFloat(getComputedStyle(pin).top) || 0;
      const viewport = innerHeight;
      const heroRect = shell.getBoundingClientRect();
      const heroTravel = Math.max(1, heroRect.height - hero.getBoundingClientRect().height);
      const zoom = motion.matches ? 0 : clamp((top - heroRect.top) / heroTravel);
      const storyRect = story.getBoundingClientRect();
      const entry = motion.matches ? 1 : clamp((zoom - (mobile.matches ? .5 : .35)) / (mobile.matches ? .4 : .5));
      hero.style.setProperty('--mh-image-zoom', String(mobile.matches ? clamp((zoom - .12) / .88) : zoom));
      hero.style.setProperty('--mh-zoom', String(zoom));
      hero.style.setProperty('--mh-dark', String(clamp((zoom - (mobile.matches ? .35 : .2)) / .6)));
      hero.style.setProperty('--mh-wheel-reveal', String(clamp((zoom - .4) / .4) * (1 - entry)));
      story.style.setProperty('--mh-story-entry', String(entry));
      story.style.setProperty('--mh-aperture', String(motion.matches ? 1 : clamp((zoom - .25) / .7)));
      story.style.setProperty('--mh-total-progress', String(clamp((top - storyRect.top) / Math.max(1, storyRect.height - pin.getBoundingClientRect().height))));
      pin.toggleAttribute('data-mh-inactive', entry < .85);
      pin.inert = entry < .85;
      const inactiveCopy = zoom > (mobile.matches ? .1 : .45);
      copies?.toggleAttribute('data-mh-copy-inactive', inactiveCopy);
      if (copies) copies.inert = inactiveCopy;
      const travel = Math.max(1, storyRect.height - pin.getBoundingClientRect().height - heroTravel);
      const progress = clamp((top - storyRect.top - heroTravel) / travel);
      const weighted = progress * (panels.length + (mobile.matches ? .5 : 0));
      const firstWeight = mobile.matches ? 1.5 : 1;
      const chapter = Math.min(panels.length - 1, weighted < firstWeight ? 0 : Math.floor(weighted - firstWeight) + 1);
      const local = clamp(chapter === 0 ? weighted / firstWeight : weighted - firstWeight - chapter + 1);
      story.style.setProperty('--mh-chapter-progress', String(local));
      if (manualScroll !== null && Math.abs(scrollRoot().scrollTop - manualScroll) > 80) manualScroll = null;
      if (!motion.matches && manualScroll === null && panels.length && !(story.contains(document.activeElement) && document.activeElement.matches(':focus-visible'))) select(panels[chapter].dataset.mhChapterPanel);
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    document.addEventListener('scroll', queue, {passive:true,capture:true});
    window.addEventListener('resize', queue, {passive:true});
    motion.addEventListener('change', queue);
    document.querySelectorAll('[data-mh-open-vehicle]').forEach(link => link.addEventListener('click', event => {
      if (!desktop.matches && window.mayhemOpenVehiclePicker?.(link)) event.preventDefault();
    }));
    hero.querySelector('.mh-hero__scroll')?.addEventListener('click', event => {
      if (motion.matches || !story || !pin) return;
      event.preventDefault();
      const top = parseFloat(getComputedStyle(pin).top) || 0;
      const distance = Math.max(0, shell.getBoundingClientRect().height - hero.getBoundingClientRect().height);
      scrollRoot().scrollTo({top:scrollRoot().scrollTop + story.getBoundingClientRect().top - top + distance,behavior:'smooth'});
    });
    const revealNodes = [...document.querySelectorAll('[data-mh-reveal]')];
    if (!motion.matches && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('mh-motion');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.remove('mh-pending'); entry.target.classList.add('mh-visible'); observer.unobserve(entry.target); }
      }), {threshold:.08});
      revealNodes.forEach(node => { if (node.getBoundingClientRect().top > innerHeight) node.classList.add('mh-pending'); observer.observe(node); });
    }
    warm(0);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
